<template>
  <div>
    <vue-title :title="$t('identityProvider:fraudControl:challenge:title')"></vue-title>
    <h1 class="section-title">{{ $t('identityProvider:fraudControl:challenge:title') }}</h1>
    <form ref="form" action="authentication/challenge" @submit.prevent="validateBeforeSubmit">
      <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-secureNow-challenge" v-if="model.showError && !errors.any()">
        <i class="material-icons">warning</i>
        <span v-if="model.errorMessage">{{ model.errorMessage }}</span>
        <span v-else class="alert-message" data-test-element="alert-message">{{ $t('validation:summary') }}</span>
      </div>
      <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" v-show="errors.any()">
        <span class="alert-icon">&#9888;</span>
        <span v-if="errors.has('.')">{{ errors.first('.') }}</span>
        <span v-else class="alert-message" data-test-element="alert-message">{{ $t('validation:summary') }}</span>
      </div>
      <fieldset>
        <div class="panel-message">
          <span v-if="model.isSecurityQuestionsRequired">{{ $t('identityProvider:fraudControl:challenge:resetSecurityQuestionsInstructions') }}</span>
          <span v-else>{{ $t('identityProvider:fraudControl:challenge:instructions') }}</span>
        </div>
        <div class="form-container">
          <div class="form-group">
            <label data-test-element="challenge-question">
              <span class="label -inline">{{ $t('identityProvider:fraudControl:challenge:prompt') }}</span>
              {{ model.prompt }}
            </label>
          </div>
          <div class="form-group">
            <label class="security-answer">
              <span class="label">{{ $t('identityProvider:fraudControl:challenge:answer') }}</span>
              <input type="password" name="Answer" ref="answer" data-test-element="Answer" class="control" v-model="model.answer" v-focus v-validate="'required'" :data-vv-as="$t('identityProvider:fraudControl:challenge:answer')" v-bind:class="{ 'input-validation-error': hasErrorOn('Answer') }" autocomplete="off" />
              <span class="field-validation-error" v-show="hasErrorOn('Answer')">{{ errors.first('Answer') }}</span>
            </label>
            <label class="show-answer checkbox">
              <input type="checkbox" data-test-element="checkbox" @change="changeVisibility" />
              <i class="material-icons checkbox-icon"></i>
              {{ $t('shared:action:showAnswer') }}
            </label>
          </div>
          <div class="form-actions">
            <button type="submit" name="Action:SecurityQuestion" data-test-element="submitBtn" class="button" :disabled="disabled">{{ $t('shared:action:continue') }}</button>
            <a @click.prevent="loginCancel" href="authentication/logincancel" class="link link-text-transform button-secondary">{{ $t('shared:action:cancel') }}</a>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<style>
</style>

<script>
  import $ from 'jquery';
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';

  export default {
    mixins: [
      validation
    ],

    props: {
      mfaChallenge: {
        type: Object
      }
    },

    data() {
      return {
        model: {
          prompt: null,
          answer: null,
          isMFAChallenge: true
        },
        disabled: false
      };
    },

    methods: {
      async changeVisibility(event) {
        this.$refs.answer.type = event.target.checked ? 'text' : 'password';
      },

      validateBeforeSubmit() {
        this.$validator.reset()
          .then(_ => {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.post();
              }
            });
          });
      },

      async post() {
        let form = this.$refs.form;
        this.disabled = true;
        try {
          let response = await this.$http.post(form.action, this.model);
          redirectHandler.checkAndRedirect(response, this.$router);
        } catch (error) {
          // If there's a new prompt, the user has a new question to answer.
          if (error.response.data && error.response.data.prompt) {
            this.model = error.response.data;
            return;
          } else if (this.validateResponse(form, error.response)) {
            // The error wasn't a new question, it was validation.
            return;
          }
          throw error;
        } finally {
          this.disabled = false;
        }
      },

      async loginCancel(event) {
        try {
          let response = await this.$http.post(event.target.href);
          redirectHandler.checkAndRedirect(response, this.$router);
        } catch (error) {
          let form = this.$refs.form;
          if (this.validateResponse(form, error.response)) {
            return;
          }
          throw error;
        }
      }
    },

    async mounted() {
      try {
        let response = this.mfaChallenge;
        redirectHandler.checkAndRedirect(response, this.$router);
        this.model = response.data;
        setTimeout(() => {
          window.scrollTo(0, 0);
        })
      } catch (error) {
        let form = this.$refs.form;
        if (this.validateResponse(form, error.response)) {
          return;
        }
        throw error;
      }
    }
  };
</script>
